import apis from "../../core/apis.js";

class TopupResource {
  constructor($resource) {
    "ngInject";

    this.$resource = $resource;
  }

  getAll(params) {
    return this.$resource(apis.topup).get(params);
  }

  get(id) {
    return this.$resource(apis.topup + id).get();
  }

  post(id, params) {
    return this.$resource(apis.user + id + "/topup").save(params);
  }
}

export default TopupResource;



// WEBPACK FOOTER //
// ./src/resources/topup/topup.resource.js